import React from 'react';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { UserMessage } from '../LiliUserMessage/UserMessage';
import { ACTION_MODAL_TYPES, IActionModalProps } from './ActionModal.types';
import { CloseButton } from '../LiliCloseButton/CloseButton';

export const ActionModal = (props: IActionModalProps) => {
  const {
    title,
    description,
    mainButtonTitle,
    cancelButtonTitle,
    onSubmit,
    onCancel,
    isLoading,
    modalType = ACTION_MODAL_TYPES.DEFAULT,
    disclaimerText,
  } = props;

  const getMainButtonStyleByModalType = (): LiliButtonType => {
    switch (modalType) {
      case ACTION_MODAL_TYPES.DESTRUCTIVE:
        return LiliButtonType.DESTRUCTIVE;
      case ACTION_MODAL_TYPES.DEFAULT:
        return LiliButtonType.PRIMARY;
      default:
        return LiliButtonType.PRIMARY;
    }
  };

  const getSecondairyButtonStyleByModalType = (): LiliButtonType => {
    switch (modalType) {
      case ACTION_MODAL_TYPES.DESTRUCTIVE:
        return LiliButtonType.TERTIARY;
      case ACTION_MODAL_TYPES.DEFAULT:
        return LiliButtonType.TERTIARY;
      default:
        return LiliButtonType.TERTIARY;
    }
  };

  return (
    <UserMessage onClick={onCancel} id=''>
      <div className='flex flex-col bg-bw00 rounded-[12px]  animate-fadeIn px-[16px] py-[16px] w-[389px] '>
        <CloseButton className='self-end' id='close_button' onClick={onCancel} />
        <div>
          <p className='text-center mb-[16px] font-metricRBold text-[18xp] text-bw08'>{title}</p>
          {description && (
            <p className='text-center px-[20px] mb-[36px] font-metricRtext-[16xp] text-bw07'>{description}</p>
          )}
          <div className='flex flex-row w-full gap-6 px-[24px] mb-[12px]'>
            <LiliButton
              id='cancel_button'
              title={cancelButtonTitle}
              onClick={onCancel}
              type={getSecondairyButtonStyleByModalType()}
            />
            <LiliButton
              id='submit_button'
              title={mainButtonTitle}
              onClick={onSubmit}
              isLoading={isLoading}
              disabled={isLoading}
              type={getMainButtonStyleByModalType()}
            />
          </div>
          {disclaimerText && (
            <div className='font-metricRtext text-[10px] text-bw07 mt-[36px] text-center px-[20px]'>
              {disclaimerText}
            </div>
          )}
        </div>
      </div>
    </UserMessage>
  );
};
